import { create } from 'zustand';

import type { components } from '../api/schema';

// Auth store (PRD §9.4 + docs/frontend_architecture.md §6).
//
// In-memory only — never persisted. The refresh-token cookie is the
// durable half of the auth pair, set httpOnly by the backend on
// /auth/login and /auth/refresh; the access token lives here for the
// lifetime of the tab and is replaced by the refresh timer (see
// useAuthRefreshTimer) before it expires.
//
// `user` mirrors the shape returned by GET /api/v1/auth/me — including
// the user's organizations, which downstream chrome (TopBar org
// switcher, route guards) reads without a second fetch.

export type AuthUser = components['schemas']['UserMeResponse'];

interface AuthStore {
  accessToken: string | null;
  expiresAt: number | null;
  user: AuthUser | null;
  setToken: (accessToken: string, expiresAt: number) => void;
  setUser: (user: AuthUser | null) => void;
  clearSession: () => void;
}

export const useAuthStore = create<AuthStore>((set) => ({
  accessToken: null,
  expiresAt: null,
  user: null,
  setToken: (accessToken, expiresAt) => {
    set({ accessToken, expiresAt });
  },
  setUser: (user) => {
    set({ user });
  },
  clearSession: () => {
    set({ accessToken: null, expiresAt: null, user: null });
  },
}));
